module.exports = __webpack_public_path__ + "img/userB01.9f32ed56.jpg";